export class CollectionRemoveThumbnailModel {
    public collectionIdList: Array<number>;

    constructor() {
        this.collectionIdList = new Array<number>();
    }
}
